import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Apple, CreditCard } from '@mui/icons-material';

import useLogger from '../../../../../hooks/useLogger';
import subscriptionSubmissionTypes from '../../subscriptionSubmissionTypes';
import {
  StyledOnboardingCard,
  ButtonContainer,
  StyledCheckoutActionButton,
} from './styles';

import texts from './texts.json';

const CheckoutActions = ({
  applePayPaymentRequest,
  selectedPaymentType,
  setSelectedPaymentType,
  isDarkTheme,
  className,
}) => {
  const { logEvent } = useLogger();

  const onClickApplePay = useCallback(() => {
    if (applePayPaymentRequest) {
      applePayPaymentRequest.show();
      logEvent('applePayShown');
    }
    setSelectedPaymentType(subscriptionSubmissionTypes.APPLE_PAY);
  }, [applePayPaymentRequest, logEvent, setSelectedPaymentType]);

  return (
    <StyledOnboardingCard className={className}>
      <ButtonContainer>
        <StyledCheckoutActionButton
          $isSelected={selectedPaymentType === subscriptionSubmissionTypes.CARD_PAYMENT}
          $isDarkTheme={isDarkTheme}
          onClick={() => setSelectedPaymentType(subscriptionSubmissionTypes.CARD_PAYMENT)}
        >
          <CreditCard />
          {texts.checkoutWithCard}
        </StyledCheckoutActionButton>
        <StyledCheckoutActionButton
          $isSelected={selectedPaymentType === subscriptionSubmissionTypes.APPLE_PAY}
          $isDarkTheme={isDarkTheme}
          onClick={onClickApplePay}
        >
          <Apple />
          {texts.applePay}
        </StyledCheckoutActionButton>
      </ButtonContainer>
    </StyledOnboardingCard>
  );
};

CheckoutActions.propTypes = {
  applePayPaymentRequest: PropTypes.object,
  className: PropTypes.string,
  selectedPaymentType: PropTypes.string.isRequired,
  setSelectedPaymentType: PropTypes.func.isRequired,
  isDarkTheme: PropTypes.bool.isRequired,
};

CheckoutActions.defaultProps = {
  applePayPaymentRequest: null,
  className: '',
};

export default CheckoutActions;
